<!-- header -->
<div class="header" id="header">
    <div class="headerWrap">
        <div class="topHead">
            <a class="mobiTggBtn toggleBtn nav-closed">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-menu-2" width="32"
                    height="32" viewBox="0 0 24 24" stroke-width="1" stroke="#000" fill="none" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M4 6l16 0" />
                    <path d="M4 12l16 0" />
                    <path d="M4 18l16 0" />
                </svg>
                <svg width="22" height="26" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1.45037" y1="0.962448" x2="35.136" y2="32.3748" stroke="black" />
                    <line x1="0.659001" y1="32.0484" x2="34.3447" y2="0.63599" stroke="black" />
                </svg>
            </a>
            <div class="top-search mobiSearch">
                <a class="closeTgg">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="26"
                        height="26" viewBox="0 0 24 24" stroke-width="1" stroke="#000000" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M18 6l-12 12" />
                        <path d="M6 6l12 12" />
                    </svg>
                </a>
                <input id="search-key" type="text" placeholder="" [(ngModel)]="key" (keydown.enter)="handleOnSearch();"
                    class="ng-valid ng-touched ng-dirty">
                <a (click)="handleOnSearch();">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <circle cx="18.5" cy="18.5" r="7.75" stroke="#3E3A39" stroke-width="1.5" />
                        <path d="M24 24L30 30" stroke="#3E3A39" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </a>
            </div>
            <a class="mobiTggBtn mobiSearchBtn">
                <svg _ngcontent-jic-c62="" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                    fill="none">
                    <circle _ngcontent-jic-c62="" cx="18.5" cy="18.5" r="7.75" stroke="#3E3A39" stroke-width="1.5">
                    </circle>
                    <path _ngcontent-jic-c62="" d="M24 24L30 30" stroke="#3E3A39" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </a>
            <h1 class="ml-80">
                <a routerLink="/" title="HOME" class="logo">
                    <img src="./assets/img/logo.svg" alt="logo IAM Globlenet">
                </a>
            </h1>
            <!-- <a class="mobiTggBtn">
                <ng-container *ngFor="let item of rightMenu;">
                    <ng-container
                        *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <ng-container *ngIf="userKind != '00' && item.prgId != 'mr.Logout' && item.prgId != 'mr.Login'">
                            <li>
                                <a href="javascript:;" (click)="handleOnClickRightMenu(item);">
                                    <img [src]="'./assets/lasted/img/' + item.icon + '.svg'">
                                </a>
                            </li>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </a>
            <a class="mobiTggBtn">
                <li *ngIf="isLogined">
                    <a routerLink="/shopping-mall/cart" class="cart-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect x="15" y="9" width="10" height="8" rx="3" stroke="#3E3A39" stroke-width="1.5" />
                            <path
                                d="M11.8843 15.8678C11.9505 15.371 12.3743 15 12.8755 15H27.1245C27.6257 15 28.0495 15.371 28.1157 15.8678L29.849 28.8678C29.929 29.4673 29.4626 30 28.8578 30H11.1422C10.5374 30 10.071 29.4673 10.151 28.8678L11.8843 15.8678Z"
                                fill="white" stroke="#3E3A39" stroke-width="1.5" />
                        </svg>
                        <div class="items-mumber"><span>{{ sumPdtCnt | setComma :'':''}}</span></div>
                    </a>
                </li>
            </a> -->
        </div>
        <!-- top right menu -->
        <div class="top-right-menu">
            <div class="top-search">
                <input id="search-key" type="text" placeholder="" [(ngModel)]="key" (keydown.enter)="handleOnSearch();"
                    class="ng-valid ng-touched ng-dirty">
                <a (click)="handleOnSearch();">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <circle cx="18.5" cy="18.5" r="7.75" stroke="#3E3A39" stroke-width="1.5" />
                        <path d="M24 24L30 30" stroke="#3E3A39" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </a>
            </div>
            <ul class="topAccount">
                <ng-container *ngFor="let item of rightMenu;">
                    <ng-container
                        *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                        <ng-container *ngIf="userKind == '00' && item.consumerYn == 'Y'">
                            <li>
                                <a href="javascript:;" (click)="handleOnClickRightMenu(item);">
                                    <img [src]="'./assets/lasted/img/' + item.icon + '.svg'">
                                </a>
                            </li>
                        </ng-container>
                        <ng-container *ngIf="userKind != '00'">
                            <li>
                                <a href="javascript:;" (click)="handleOnClickRightMenu(item);">
                                    <img [src]="'./assets/lasted/img/' + item.icon + '.svg'">
                                </a>
                            </li>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <li>
                    <a routerLink="/my-office/order-management/prepay" class="prepay-icon">
                        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
                            style="enable-background:new 0 0 40 40;" xml:space="preserve">
                            <style type="text/css">
                                .st0 {
                                    fill: #3E3A39;
                                }

                                .st1 {
                                    fill: none;
                                    stroke: #3E3A39;
                                    stroke-width: 1.5;
                                    stroke-miterlimit: 10;
                                }
                            </style>
                            <g id="_x30_2">
                                <g>
                                    <rect x="6.2" y="15.8" class="st0" width="26" height="3" />
                                </g>
                                <g>
                                    <path class="st0" d="M18.7,21.8h-8c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5h8c0.3,0,0.5,0.2,0.5,0.5v0C19.2,21.6,19,21.8,18.7,21.8z" />
                                </g>
                                <g>
                                    <path class="st0" fill="3E3A39" d="M14.7,23.8h-4c-0.3,0-0.5-0.2-0.5-0.5v0c0-0.3,0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5v0C15.2,23.6,15,23.8,14.7,23.8z" />
                                </g>
                                <path class="st1" d="M32.2,21.9v-8.7c0-1.7-1.3-3-3-3h-20c-1.7,0-3,1.3-3,3v12.9c0,1.7,1.3,3,3,3h17.7c0.7,0.5,1.5,0.7,2.4,0.7c2.5,0,4.5-2,4.5-4.5C33.8,23.9,33.2,22.7,32.2,21.9z" />
                                <circle class="st1" cx="29.3" cy="25.3" r="4.5" />
                                <path class="st0" d="M31.8,23.5c-0.3-0.3-0.7-0.3-0.9,0l-2.3,2.3L27.8,25c-0.3-0.3-0.7-0.3-0.9,0s-0.3,0.7,0,0.9l1.2,1.2c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l2.7-2.7C32,24.2,32,23.8,31.8,23.5z" />
                            </g>
                        </svg>
                    </a>
                </li>
                <li *ngIf="isLogined" class="topCart">
                    <a routerLink="/shopping-mall/cart" class="cart-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect x="15" y="9" width="10" height="8" rx="3" stroke="#3E3A39" stroke-width="1.5" />
                            <path
                                d="M11.8843 15.8678C11.9505 15.371 12.3743 15 12.8755 15H27.1245C27.6257 15 28.0495 15.371 28.1157 15.8678L29.849 28.8678C29.929 29.4673 29.4626 30 28.8578 30H11.1422C10.5374 30 10.071 29.4673 10.151 28.8678L11.8843 15.8678Z"
                                fill="white" stroke="#3E3A39" stroke-width="1.5" />
                        </svg>
                        <div class="items-mumber"><span>{{ sumPdtCnt | setComma :'':''}}</span></div>
                    </a>
                </li>
                <li class="topLang">
                    <div (click)="handleOnClickSelectDropdown();">
                        <a href="#none">{{(selected)?selected.label:'' }}
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                                width="32" height="32" viewBox="0 0 24 24" stroke-width="1" stroke="#333333" fill="none"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M6 9l6 6l6 -6" />
                            </svg>
                        </a>
                    </div>
                    <div class="options" [ngClass]="showOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
                        <ng-template ngFor let-item [ngForOf]="options">
                            <a class="option row" [attr.data-lang]="item.value" (click)="handleOnClickOption(item);">{{
                                item.label }}</a>
                        </ng-template>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</div>
<!-- main menu -->
<div class="main-menu text-center d-flex">
    <ul class="ul-main-menu gnb">
        <li class="dropdown" [ngClass]="activeTopLeft == 'ml.About'?'active':''">
            <a [routerLink]="'/about/who-iam'">About</a>
            <div class="dropdown-content">
                <h2>Abouts</h2>
                <a [routerLink]="'/about/who-iam'">Who IAM</a>
                <a [routerLink]="'/about/how-iam'">How IAM</a>
                <a [routerLink]="'/about/what-iam'">What IAM</a>
                <a [routerLink]="'/about/why-iam'">Why IAM</a>
            </div>
        </li>
        <ng-container *ngFor="let item of leftmenu">
            <ng-container *ngIf="item.menuYn == 'Y'">
                <li [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">
                    <ng-container *ngIf="item.prgId == 'ml.My-office'">
                        <a (click)="handleOnClickLeftMenu(item);" style="cursor: pointer;">
                            <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                            <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="item.prgId != 'ml.My-office'">
                        <ng-container *ngIf="item.prgId == 'ml.Home'">
                            <a style="cursor: pointer;" [routerLink]="item.linkInfo"
                                (click)="handleOnClickAllCategory('All', 'All');">
                                <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="item.prgId != 'ml.Home'">
                            <a [routerLink]="item.linkInfo">
                                <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                            </a>
                        </ng-container>
                    </ng-container>
                </li>
            </ng-container>
        </ng-container>
        <li>
            <a (click)="handleOnClickAutoship();">정기구독</a>
        </li>
    </ul>
</div>
<div class="hdTopBanner">
    <a href="/shopping-mall/product/01110001" class="contain">
        <p>텐텐한 피부신화, 10년을 젊게, 10년을 아름답게</p>
        <p>GF COS PREBIOTICS MIST SERUM</p>
    </a>
</div>
<!-- //header -->

<!-- mobile menu -->
<div class="mobiTggMenu">
    <!-- <a class="mobiTggClo">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="26" height="26"
            viewBox="0 0 24 24" stroke-width="1" stroke="#000000" fill="none" stroke-linecap="round"
            stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
        </svg>
    </a> -->
    <div class="gnbClone">
        <ul class="ul-main-menu gnb">
            <li class="topLang mobi-menu-item" [ngClass]="activeTopLeft == 'ml.About'?'active':''">
                <div class="d-flex justify-content-center">
                    <a [routerLink]="'/about/who-iam'" class="mobile-menu fw-bold" style="cursor: pointer;">
                        Abouts
                    </a>
                    <ng-container>
                        <div class="btn-open-sub col-auto me-3 position-absolute"
                            [ngClass]="activeTopLeft === 'ml.About' ? 'opened' : ''">
                            <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
                                <path d="M0 7.99974H15.9995" stroke="black" />
                                <path d="M8 0.000518799L8 16" stroke="black" />
                            </svg>
                        </div>
                    </ng-container>
                </div>
                <ul class="mobi-sub-item">
                    <li class="topLang" [ngClass]="url.includes('who-iam') == true ?'active':''"
                        [routerLink]="'/about/who-iam'">Who IAM</li>
                    <li class="topLang" [ngClass]="url.includes('how-iam') == true ?'active':''"
                        [routerLink]="'/about/how-iam'">How IAM</li>
                    <li class="topLang" [ngClass]="url.includes('what-iam') == true ?'active':''"
                        [routerLink]="'/about/what-iam'">What IAM</li>
                    <li class="topLang" [ngClass]="url.includes('why-iam') == true ?'active':''"
                        [routerLink]="'/about/why-iam'">Why IAM</li>
                </ul>
            </li>

            <ng-container *ngFor="let item of leftmenu; index as i;">
                <ng-container *ngIf="item.menuYn == 'Y'">
                    <li class="topLang mobi-menu-item" [ngClass]="item.prgId === activeTopLeft ? 'active' : ''">
                        <ng-container *ngIf="item.prgId == 'ml.My-office'">
                            <div class="d-flex justify-content-center">
                                <a class="mobile-menu fw-bold" (click)="handleOnClickLeftMenu(item);"
                                    style="cursor: pointer;">
                                    <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                    <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                                </a>
                                <div class="btn-open-sub col-auto me-3 position-absolute" *ngIf="isLogined"
                                    [ngClass]="item.prgId === activeTopLeft ? 'opened' : ''">
                                    <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
                                        <path d="M0 7.99974H15.9995" stroke="black" />
                                        <path d="M8 0.000518799L8 16" stroke="black" />
                                    </svg>
                                </div>
                            </div>
                            <ul class="mobi-sub-item">
                                <ng-container *ngFor="let item of mainMenu">
                                    <ng-container
                                        *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                                        <ng-container
                                            *ngIf="item.prgKind === 'mo' && item.menuLv === '1' && item.menuYn === 'Y'
                                                    && ((userKind == '00' && item.consumerYn == 'Y') || userKind != '00')">
                                            <li class="topLang" [ngClass]="activeId === item.prgId ? 'active' : ''">
                                                <a [routerLink]="item.linkInfo" class="level-1"
                                                    (click)="handleOnClickCategory(item);">
                                                    {{ item.prgName }}
                                                </a>
                                            </li>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </ng-container>
                        <ng-container *ngIf="item.prgId != 'ml.My-office'">
                            <ng-container *ngIf="item.prgId == 'ml.Home'">
                                <div class="d-flex justify-content-center">
                                    <a class="mobile-menu fw-bold" style="cursor: pointer;"
                                        (click)="handleOnClickAllCategory('All', 'All');">{{ item.prgName }}</a>
                                    <div class="btn-open-sub col-auto me-3 position-absolute"
                                        [ngClass]="item.prgId === activeTopLeft ? 'opened' : ''">
                                        <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
                                            <path d="M0 7.99974H15.9995" stroke="black" />
                                            <path d="M8 0.000518799L8 16" stroke="black" />
                                        </svg>
                                    </div>
                                </div>
                                <ul class="mobi-sub-item">
                                    <ng-container *ngFor="let item of pdtCates">
                                        <ng-container *ngIf="item.lv != '1'">
                                            <li class="topLang"
                                                [ngClass]="activeCate.includes(item.cateCd) === true ? 'active' : ''">
                                                <a (click)="handleOnClickAllCategory(item.cateCd, item.cateName);">
                                                    {{ item.cateName }}
                                                </a>
                                            </li>
                                        </ng-container>
                                    </ng-container>
                                    <li class="topLang"
                                        [ngClass]="activeCate.includes('wish') === true ? 'active' : ''">
                                        <a (click)="handleOnClickAllCategory('wish', '관심상품');">
                                            관심상품
                                        </a>
                                    </li>
                                    <li class="topLang">
                                        <a (click)="handleOnClickAutoship();">
                                            정기구독
                                        </a>
                                    </li>
                                </ul>
                            </ng-container>
                            <ng-container *ngIf="item.prgId != 'ml.Home'">
                                <a class="mobile-menu" [routerLink]="item.linkInfo">
                                    <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                    <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                                </a>
                            </ng-container>
                        </ng-container>
                    </li>
                </ng-container>
            </ng-container>
            <li class="topLang mobi-menu-item">
                <a (click)="handleOnClickAutoship();" class="mobile-menu fw-bold" style="cursor: pointer;">
                    정기구독
                </a>
            </li>
        </ul>
    </div>
    <!-- top right menu mobile -->
    <div class="accountClone">
        <ul class="topAccount">
            <!-- <ng-container *ngFor="let item of rightMenu;">
                <ng-container
                    *ngIf="item.loginYn == 'A' || (isLogined && item.loginYn == 'Y') || (!isLogined && item.loginYn == 'N')">
                    <ng-container
                        *ngIf="userKind == '00' && item.consumerYn == 'Y' && (item.prgId == 'mr.Logout' || item.prgId == 'mr.Login')">
                        <li>
                            <a class="mobile-menu me-3" href="javascript:;" (click)="handleOnClickRightMenu(item);">
                                <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                            </a>
                        </li>
                    </ng-container>
                    <ng-container *ngIf="userKind != '00' && (item.prgId == 'mr.Logout' || item.prgId == 'mr.Login')">
                        <li>
                            <a class="mobile-menu me-3" href="javascript:;" (click)="handleOnClickRightMenu(item);">
                                <ng-container *ngIf="lang === 'kr'">{{ item.prgName }}</ng-container>
                                <ng-container *ngIf="lang === 'en'">{{ item.prgNameEn }}</ng-container>
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
            <li *ngIf="isLogined">
                <a routerLink="/shopping-mall/cart">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                        fill="none">
                        <rect x="15" y="9" width="10" height="8" rx="3" stroke="#3E3A39"
                            stroke-width="1.5" />
                        <path
                            d="M11.8843 15.8678C11.9505 15.371 12.3743 15 12.8755 15H27.1245C27.6257 15 28.0495 15.371 28.1157 15.8678L29.849 28.8678C29.929 29.4673 29.4626 30 28.8578 30H11.1422C10.5374 30 10.071 29.4673 10.151 28.8678L11.8843 15.8678Z"
                            fill="white" stroke="#3E3A39" stroke-width="1.5" />
                    </svg>
                    <div class="items-mumber"><span>{{ sumPdtCnt | setComma :'':''}}</span></div>
                </a>
            </li> -->
            <!-- select lang -->
            <li class="topLang">
                <div (click)="handleOnClickSelectDropdown();">
                    <a class="me-2" href="javascript:;">{{(selected)?selected.label:'' }}
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                            width="32" height="32" viewBox="0 0 24 24" stroke-width="1" stroke="#333333" fill="none"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M6 9l6 6l6 -6" />
                        </svg>
                    </a>
                </div>
                <div class="options" [ngClass]="showOptions ? 'open-dropdown-select' : 'close-dropdown-select'">
                    <ng-template ngFor let-item [ngForOf]="options">
                        <a class="mobile-menu" class="option row" [attr.data-lang]="item.value"
                            (click)="handleOnClickOption(item);">{{ item.label }}</a>
                    </ng-template>
                </div>
            </li>
        </ul>
    </div>
</div>

<div id="main-menu" class="bg-gray-product-category">
    <div class="container main-menu-container">
        <div class="row containing-row">
            <!-- <ng-container *ngIf="kind === kindMenuOffice">
                <div class="big-title-page-mobile text-center mobiTggBtn">
                    {{menuHeaderName}}
                </div>
            </ng-container> -->
            <div id="main-nav" class="col"
                *ngIf="!url.startsWith('/login') && (url.startsWith('/shopping-mall') || url.startsWith('/my-office'))">
                <!-- title shopping-mall -->
                <div class="big-title-page text-center">
                    {{menuHeaderName}}
                </div>
                <div class="gnbClone" *ngIf="url.includes('shopping-mall')">
                    <ul class="row main-menu-s-small shopMenu">
                        <ng-container *ngFor="let item of mainItems; index as i">
                            <ng-container
                                *ngIf="(item.data.menuYn === 'Y') && (item.data.loginYn == 'A' || (isLogined && item.data.loginYn == 'Y') || (!isLogined && item.data.loginYn == 'N'))">
                                <ng-container
                                    *ngIf="(userKind == '00' && item.data.consumerYn == 'Y') || userKind != '00'">
                                    <li class="menu-item col-auto" [attr.data-program-id]="item.data.prgId"
                                        [ngClass]="activeId === item.data.prgId ? 'active' : ''">

                                        <ng-container *ngIf="kind !== kindMenuHome && kind !== kindMenuShopping">
                                            <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgName
                                                }}</a>
                                        </ng-container>

                                        <ng-container *ngIf="kind === kindMenuHome || kind === kindMenuShopping">
                                            <a [routerLink]="item.data.linkInfo" class="level-1"
                                                (click)="handleOnClickCategory(item);">
                                                {{ item.data.prgName }}
                                            </a>
                                        </ng-container>

                                    </li>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ul>
                    <!-- <ul class="ul-main-menu gnb">
                        <li class="topLang mobi-menu-item">
                            <span href="#none" class="mbShopMenu">
                                {{activeCateName}}

                                <div class="btn-open-sub opened">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                            </span>
                            <ul class="mobi-sub-item row main-menu" style="display: none;">
                                <li class="topLang" [ngClass]="activeCate.includes('All') === true ? 'active' : ''">
                                    <a (click)="handleOnClickAllCategory('All', 'All');">
                                        All
                                    </a>
                                </li>
                                <ng-container *ngFor="let item of pdtCates">
                                    <ng-container *ngIf="item.lv != '1'">
                                        <li class="topLang"
                                            [ngClass]="activeCate.includes(item.cateCd) === true ? 'active' : ''">
                                            <a (click)="handleOnClickAllCategory(item.cateCd, item.cateName);">
                                                {{ item.cateName }}
                                            </a>
                                        </li>
                                    </ng-container>
                                </ng-container>
                                <li class="topLang" [ngClass]="activeCate.includes('wish') === true ? 'active' : ''">
                                    <a (click)="handleOnClickAllCategory('wish', '관심상품');">
                                        관심상품
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul> -->
                </div>
                <!-- End title shopping-mall -->
                <ul class="row main-menu shopMenu">
                    <ng-container *ngFor="let item of mainItems; index as i">
                        <ng-container
                            *ngIf="(item.data.menuYn === 'Y') && (item.data.loginYn == 'A' || (isLogined && item.data.loginYn == 'Y') || (!isLogined && item.data.loginYn == 'N'))">
                            <ng-container *ngIf="(userKind == '00' && item.data.consumerYn == 'Y') || userKind != '00'">
                                <li class="menu-item col-auto" [attr.data-program-id]="item.data.prgId"
                                    [ngClass]="activeId === item.data.prgId ? 'active' : ''">

                                    <ng-container *ngIf="kind !== kindMenuHome && kind !== kindMenuShopping">
                                        <a [routerLink]="item.data.linkInfo" class="level-1">{{ item.data.prgName }}</a>
                                    </ng-container>

                                    <ng-container *ngIf="kind === kindMenuHome || kind === kindMenuShopping">
                                        <a [routerLink]="item.data.linkInfo" class="level-1"
                                            (click)="handleOnClickCategory(item);">
                                            {{ item.data.prgName }}
                                        </a>
                                    </ng-container>

                                </li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <li class="menu-item col-auto">
                        <a class="level-1" (click)="handleOnClickAutoship();">정기구독</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<board-popup></board-popup>
<app-autologout style="display: none;"></app-autologout>
<ngx-loading [show]="loading"></ngx-loading>